import { dateToTimestamp } from 'shared/helpers/parsers/date';
import { removeCommasAndParse } from 'shared/helpers/parsers/text';

const parseEnterPaymentData = payment => ({
  relatedCompany: payment.relatedCompany.value,
  relatedLot: payment.relatedLot.value,
  paymentType: payment.paymentType.value,
  fundsType: payment.fundsType.value,
  paymentAmount: removeCommasAndParse(payment.paymentAmount),
  additionalInfo: payment.additionalInfo,
  requestedFinalPaymentDate: dateToTimestamp(payment.requestedFinalPaymentDate),
});

export { parseEnterPaymentData };
